import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=98c31514&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/menu.scss?vue&type=style&index=0&id=98c31514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c31514",
  null
  
)

export default component.exports